import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function ProductOffersSection() {
  const [copiesLeft, setCopiesLeft] = useState(71);
  // Countdown effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCopiesLeft(prev => prev > 50 ? prev - 1 : prev);
    }, 120000); // Decrease every 2 minutes
    return () => clearInterval(interval);
  }, []);
  return <section id="compra" className="py-20 px-6 bg-[#F0EBE0] scroll-mt-20" data-id="element-39">
      <div className="max-w-6xl mx-auto" data-id="element-40">
        {/* Title */}

        {/* Urgent CTA Box */}

        {/* Product Options Grid - 2x2 Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-41">
          {/* Digital Copy */}
          <motion.div whileHover={{
          y: -4
        }} className="bg-white rounded-xl p-6 shadow-lg border-2 border-[#1C1917]/10" data-id="element-42">
            <div className="mb-4" data-id="element-43">
              <h4 className="text-2xl font-bold text-[#1C1917] mb-2" data-id="element-44">
                Copia Digital
              </h4>
              <p className="text-base text-[#78716C] line-through mb-1" data-id="element-45">
                $47.97
              </p>
              <div className="mb-2" data-id="element-46">
                <span className="text-5xl font-black text-[#7F1D1D]" data-id="element-47">
                  $9.97
                </span>
              </div>
              <p className="text-base text-[#16A34A] font-semibold mb-4" data-id="element-48">
                Descarga Instantánea
              </p>

              {/* Bonus Callout Box */}
              <div className="bg-[#FEF3C7] border-l-4 border-[#FCD34D] p-3 rounded" data-id="element-49">
                <p className="text-sm font-bold text-[#78716C] mb-1" data-id="element-50">
                  Incluye 1 bono GRATIS 🎁
                </p>
                <p className="text-xs font-semibold text-[#1C1917]" data-id="element-51">
                  Mapa Estratégico Visual (PDF descargable)
                </p>
                <p className="text-xs text-[#78716C] mt-1" data-id="element-52">
                  La guerra energética global explicada de forma clara y
                  sistémica.
                </p>
              </div>
            </div>

            <div className="bg-[#F0EBE0] rounded-lg p-4 mb-4" data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/sqtjrmaovecA2RQi7zLhyq/Digital.png" alt="Digital Copy" className="w-full h-64 object-contain rounded-lg" data-id="element-54" />
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full px-6 py-3 bg-[#7F1D1D] text-white font-bold rounded-lg shadow-md hover:bg-[#991B1B] transition-colors" data-id="element-55">
              Obtener Copia Digital
            </motion.button>
          </motion.div>

          {/* Paperback */}
          <motion.div whileHover={{
          y: -4
        }} className="bg-white rounded-xl p-6 shadow-lg border-2 border-[#1C1917]/10" data-id="element-56">
            <div className="mb-4" data-id="element-57">
              <h4 className="text-2xl font-bold text-[#1C1917] mb-2" data-id="element-58">
                Libro Tapa Blanda
              </h4>
              <p className="text-base text-[#78716C] line-through mb-1" data-id="element-59">
                $67.97
              </p>
              <div className="mb-2" data-id="element-60">
                <span className="text-5xl font-black text-[#7F1D1D]" data-id="element-61">
                  $19.97
                </span>
              </div>
              <p className="text-base text-[#D97706] font-semibold mb-4" data-id="element-62">
                Envío en 15 días
              </p>

              {/* Bonus Callout Box */}
              <div className="bg-[#FEF3C7] border-l-4 border-[#FCD34D] p-3 rounded" data-id="element-63">
                <p className="text-sm font-bold text-[#78716C] mb-2" data-id="element-64">
                  Incluye 2 bonos GRATIS
                </p>
                <div className="space-y-2" data-id="element-65">
                  <div data-id="element-66">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-67">
                      🎁 Mapa Estratégico Visual (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-68">
                      La guerra energética global explicada de forma clara y
                      sistémica.
                    </p>
                  </div>
                  <div data-id="element-69">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-70">
                      🎁 Glosario Geopolítico Esencial (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-71">
                      Los conceptos que necesitas para entender el poder más
                      allá de los titulares.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#F0EBE0] rounded-lg p-4 mb-4" data-id="element-72">
              <img src="https://cdn.magicpatterns.com/uploads/jBdJWzuepheqrCCjGXTU67/ChatGPT_Image_Jan_13,_2026,_12_53_31_PM.png" alt="Paperback" className="w-full h-64 object-contain rounded-lg" data-id="element-73" />
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full px-6 py-3 bg-[#7F1D1D] text-white font-bold rounded-lg shadow-md hover:bg-[#991B1B] transition-colors" data-id="element-74">
              Ordenar Tapa Blanda
            </motion.button>
          </motion.div>

          {/* Hardcover */}
          <motion.div whileHover={{
          y: -4
        }} className="bg-white rounded-xl p-6 shadow-lg border-2 border-[#1C1917]/10" data-id="element-75">
            <div className="mb-4" data-id="element-76">
              <h4 className="text-2xl font-bold text-[#1C1917] mb-2" data-id="element-77">
                Libro Tapa Dura
              </h4>
              <p className="text-base text-[#78716C] line-through mb-1" data-id="element-78">
                $97.97
              </p>
              <div className="mb-2" data-id="element-79">
                <span className="text-5xl font-black text-[#7F1D1D]" data-id="element-80">
                  $34.97
                </span>
              </div>
              <p className="text-base text-[#D97706] font-semibold mb-4" data-id="element-81">
                Envío en 15 días
              </p>

              {/* Bonus Callout Box */}
              <div className="bg-[#FEF3C7] border-l-4 border-[#FCD34D] p-3 rounded" data-id="element-82">
                <p className="text-sm font-bold text-[#78716C] mb-2" data-id="element-83">
                  Incluye 3 bonos GRATIS
                </p>
                <div className="space-y-2" data-id="element-84">
                  <div data-id="element-85">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-86">
                      🎁 Mapa Estratégico Visual (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-87">
                      La guerra energética global explicada de forma clara y
                      sistémica.
                    </p>
                  </div>
                  <div data-id="element-88">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-89">
                      🎁 Glosario Geopolítico Esencial (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-90">
                      Los conceptos que necesitas para entender el poder más
                      allá de los titulares.
                    </p>
                  </div>
                  <div data-id="element-91">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-92">
                      🎁 Ensayo Exclusivo (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-93">
                      Por qué las sanciones no funcionan como te dijeron.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#F0EBE0] rounded-lg p-4 mb-4" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/5Q6fLogqAjPCjYchUmBKxN/HardCover.png" alt="Hardcover" className="w-full h-64 object-contain rounded-lg" data-id="element-95" />
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full px-6 py-3 bg-[#7F1D1D] text-white font-bold rounded-lg shadow-md hover:bg-[#991B1B] transition-colors" data-id="element-96">
              Ordenar Tapa Dura
            </motion.button>
          </motion.div>

          {/* Premium Bundle */}
          <motion.div whileHover={{
          y: -4
        }} className="bg-white rounded-xl p-6 shadow-lg border-2 border-[#7F1D1D] relative" data-id="element-97">
            {/* Más Popular Badge */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-98">
              <span className="inline-block px-6 py-2 bg-[#7F1D1D] text-white font-bold text-sm rounded-lg shadow-md" data-id="element-99">
                Más Popular
              </span>
            </div>

            <div className="mb-4" data-id="element-100">
              <h4 className="text-2xl font-bold text-[#1C1917] mb-2" data-id="element-101">
                Premium
              </h4>
              <p className="text-base text-[#78716C] line-through mb-1" data-id="element-102">
                $297.97
              </p>
              <div className="mb-2" data-id="element-103">
                <span className="text-5xl font-black text-[#7F1D1D]" data-id="element-104">
                  $94.97
                </span>
              </div>
              <p className="text-base text-[#D97706] font-semibold mb-4" data-id="element-105">
                Envío en 15 días
              </p>

              {/* Package Contents */}
              <div className="bg-[#7F1D1D]/5 border-2 border-[#7F1D1D]/20 rounded-lg p-3 mb-4" data-id="element-106">
                <p className="text-sm font-semibold text-[#1C1917] text-center" data-id="element-107">
                  Ebook + Tapa blanda + Tapa dura + 5 bonos GRATIS
                </p>
              </div>

              {/* Bonus Callout Box */}
              <div className="bg-[#FEF3C7] border-l-4 border-[#FCD34D] p-3 rounded" data-id="element-108">
                <p className="text-sm font-bold text-[#78716C] mb-2" data-id="element-109">
                  Incluye 5 bonos GRATIS
                </p>
                <div className="space-y-2" data-id="element-110">
                  <div data-id="element-111">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-112">
                      🎁 Mapa Estratégico Visual (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-113">
                      La guerra energética global explicada de forma clara y
                      sistémica.
                    </p>
                  </div>
                  <div data-id="element-114">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-115">
                      🎁 Glosario Geopolítico Esencial (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-116">
                      Los conceptos que necesitas para entender el poder más
                      allá de los titulares.
                    </p>
                  </div>
                  <div data-id="element-117">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-118">
                      🎁 Ensayo Exclusivo (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-119">
                      Por qué las sanciones no funcionan como te dijeron.
                    </p>
                  </div>
                  <div data-id="element-120">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-121">
                      🎁 El Mapa Bajo Tierra (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-122">
                      Guía visual para entender la geopolítica desde la energía,
                      sin discursos ni complejidad innecesaria.
                    </p>
                  </div>
                  <div data-id="element-123">
                    <p className="text-xs font-semibold text-[#1C1917]" data-id="element-124">
                      🎁 Venezuela en el Tablero Global (PDF)
                    </p>
                    <p className="text-xs text-[#78716C]" data-id="element-125">
                      Línea de tiempo energética y geopolítica para entender el
                      conflicto sin ruido ni ideología.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-[#F0EBE0] rounded-lg p-4 mb-4" data-id="element-126">
              <img src="https://cdn.magicpatterns.com/uploads/2emtCeZJdgJpsqcSbinmtB/ChatGPT_Image_Jan_14,_2026,_01_04_18_AM.png" alt="Premium Bundle" className="w-full h-80 object-contain rounded-lg" data-id="element-127" />
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full px-6 py-3 bg-[#7F1D1D] text-white font-bold rounded-lg shadow-md hover:bg-[#991B1B] transition-colors" data-id="element-128">
              Obtener Premium
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>;
}